import axios from 'axios';

import {typesUsercreddetcosmos} from '../redux/svtypes/usercreddetcosmos'

import { SV_SOJ_ORCMOCK_ADDRESS } from '../constants';

export const svauthenticateUsercredBegin = () => dispatch => {
    dispatch({
        type:typesUsercreddetcosmos.GET_SAVEUSERCREDCOSMOS_BEGIN
        
    })
}


export const getAuthenticateUsercredError = (e) =>dispatch => {
    dispatch({
        type:typesUsercreddetcosmos.GET_SAVEUSERCREDCOSMOS_ERROR,
        error:e
    })
}


export const getAuthenticateUsercredSuccess = (data) => dispatch => {
    dispatch({
        type: typesUsercreddetcosmos.GET_SAVEUSERCREDCOSMOS_SUCCESS,
        payload: data
    })
}

const getuserRecords = (rqValues) => {
    console.log('%%%%%%%%%%%%%%%sv START++++REST API For getuserRecords   rqValues')
   
    console.log(rqValues)
    console.log('%%%%%%%%%%%%%%%sv   END++++REST API For getuserRecords   rqValues')
   
   
    //let url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/dinos`
     //authenticateUsercredNowSV
     const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
     const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
     /*svj31 start*/
      const headers = {'Content-Type': 'application/json'}

        
    //let url = "http://localhost:8080/svapi/coreend/control";
    let ob = {'content-type': 'application/json'};
    return axios.post(url, rqValues, {headers:headers, timeout:7000})
}

const getgeoRecords = () => {
    console.log('%%%%%%%%%%%%%%%sv START++++REST API For getuserRecords   rqValues')
   
    
    console.log('%%%%%%%%%%%%%%%sv   END++++REST API For getuserRecords   rqValues')
   
   
    //let url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/dinos`
     //authenticateUsercredNowSV
      /*svj31 start*/
     const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
     const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
     const headers = {'Content-Type': 'application/json'}

        
    //let url = "http://localhost:8080/svapi/coreend/control";
    let ob = {'content-type': 'application/json'};
    return  axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
}

export const svauthNow = async (dispatch,rqValues)=>{
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNowSVhook  dispatch, rqValues')
    console.log(dispatch)
    console.log(rqValues)
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNowSVhook from Microservices DB swith sae key :' + rqValues)
   
    const r = await getuserRecords(rqValues)
    const r2 = await getgeoRecords()
    console.log(r);
    if (r) {
        let my_data_geo = null
                //svj31 rstart
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                
                if( r2.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     comData.my_data_geo = my_data_geo
                    }
                    console.log(comData )
                    //svaiiisd_geoPost end

                 
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                    comData.my_data_geo = null
                  
                }

                  
                if(r.data){
                   
                   if(!r.data.customerId){
                       let emsg = 'Login Failde'
                       dispatch(getAuthenticateUsercredError(emsg))
                   }
                   if(r.data.customerId < 1){
                    let emsg = 'Login Failde'
                    dispatch(getAuthenticateUsercredError(emsg))
                }
                    comData.my_data_profile = r.data
                    comData.my_data_profile.username = comData.my_data_profile.login
                    comData.my_data_profile.id = comData.my_data_profile.customerId

                    return dispatch({
                        type: "GET_SAVEUSERCREDCOSMOS_SUCCESS",
                        payload: comData
                    });
                  //  dispatch(getAuthenticateUsercredSuccess(comData))
                }
                else {
                    comData.my_data_profile = {}
                    comData.my_data_profile.status = "FAILED"
                    comData.my_data_profile.customerId = -1
                    comData.my_data_profile.login = null
                    return dispatch({
                        type: "GET_SAVEUSERCREDCOSMOS_SUCCESS",
                        payload: comData
                    });
                   // dispatch(getAuthenticateUsercredSuccess(comData))
                }
                //svj31 reend
                //svsj31 start
 


               

                //spread svj31 end
                /*
        return dispatch({
            type: "GET_SAVEUSERCREDCOSMOS_SUCCESS",
            payload: payload
        });
        */
    } else {
        console.log("Server svaith  error");
    }

}
